export const formatCpfNumber = (value: string | undefined): string => {
  if (!value) return ''
  return value
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+$/, '$1')
}

export const normalizeCpfNumber = (value: string): string => {
  return value.replace(/\./g, '').replace(/-/g, '')
}
